/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";

// Images
import bgFront1 from "assets/Cards Gustavo/março/01Frente.png";
import bgFront2 from "assets/Cards Gustavo/março/03Frente.png";
import bgFront3 from "assets/Cards Gustavo/março/05Frente.png";
/* import bgFront4 from "assets/Cards Gustavo/400.png"; */
/* import bgFront6 from "assets/Cards Gustavo/Combos site/200 MEGA + 200 MEGA (bônus portabilidade) + Mesh (Principal + Cubo) + Chip 12GB Móvel _ 129,99.png"; */
import bgBack from "assets/Cards Gustavo/março/02Verso.png";
import bgBack2 from "assets/Cards Gustavo/março/04Verso.png";
import bgBack3 from "assets/Cards Gustavo/março/06Verso.png";
/* import bgBack4 from "assets/Cards Gustavo/Combos site/Verso_-_200_MEGA_+_200_MEGA__bônus_portabilidade__+_Mesh__Principal_+_Cubo__+_Chip_12GB_Móvel___129_99-removebg-preview.png";
 */
function PlanosSobral() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container spacing={0} alignItems="center" justifyContent="center" sx={{ mx: "auto" }}>
          {/* PLANO 1 */}
          <Grid item xs={10} lg={3} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront1}
                icon="touch_app"
                title={<>500 MEGA</>}
                description="Internet de alta velocidade por apenas R$ 89,90 por mês."
              />
              <RotatingCardBack
                image={bgBack}
                description="Plano ideal para navegação, redes sociais e streaming."
                videoLink="https://api.whatsapp.com/send?phone=558009111000&text=Quero%20contratar%20o%20plano%20500%20Mega%20por%2089,90"
                action={{
                  type: "internal",
                  route:
                    "https://api.whatsapp.com/send?phone=558009111000&text=Quero%20contratar%20o%20plano%20500%20Mega%20por%2089,90",
                  label: "CONTRATE JÁ",
                }}
              />
            </RotatingCard>
          </Grid>

          {/* PLANO 2 */}
          <Grid item xs={10} lg={3} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront2}
                icon="touch_app"
                title={<>500 MEGA + WIFI MESH</>}
                description="Cobertura completa na casa toda por R$ 109,90/mês."
              />
              <RotatingCardBack
                image={bgBack2}
                description="WiFi Mesh com troca automática de sinal e estabilidade na casa toda."
                videoLink="https://api.whatsapp.com/send?phone=558009111000&text=Quero%20contratar%20500%20Mega%20+%20WiFi%20Mesh%20por%20109,90"
                action={{
                  type: "internal",
                  route:
                    "https://api.whatsapp.com/send?phone=558009111000&text=Quero%20contratar%20500%20Mega%20+%20WiFi%20Mesh%20por%20109,90",
                  label: "CONTRATE JÁ",
                }}
              />
            </RotatingCard>
          </Grid>

          {/* PLANO 3 */}
          <Grid item xs={10} lg={3} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront3}
                icon="touch_app"
                title={<>500 MEGA + WIFI MESH</>}
                description="Mais desempenho e cobertura por R$ 129,90/mês."
              />
              <RotatingCardBack
                image={bgBack3}
                description="Internet de alta velocidade com WiFi Mesh para máxima estabilidade."
                videoLink="https://api.whatsapp.com/send?phone=558009111000&text=Quero%20contratar%20500%20Mega%20+%20WiFi%20Mesh%20por%20129,90"
                action={{
                  type: "internal",
                  route:
                    "https://api.whatsapp.com/send?phone=558009111000&text=Quero%20contratar%20500%20Mega%20+%20WiFi%20Mesh%20por%20129,90",
                  label: "CONTRATE JÁ",
                }}
              />
            </RotatingCard>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default PlanosSobral;
